const ratingToStarValue = rating => {
  if (!rating) { return 0; }

  const divided = rating / 20;
  const dividedFloor = Math.floor(divided);

  return divided - dividedFloor > 0 ? dividedFloor + 0.5 : divided;
};


export {
  ratingToStarValue
};

